
import { BaseRouteService } from "core/services";

class PickTicketHeaderRouteService extends BaseRouteService {
	constructor() {
		super("pick-ticket-headers");	
	}	
	
	get(id, options) {		
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);	
	}	

	createPickTicket(facilityOrderId) {
		return super.create(`${this.base}/create-facility-order-pick-ticket/{facilityOrderId}`, { facilityOrderId });
	}

	pickTicketReportDownloadUrl(id) {
		return super.get(`${this.base}/get-pick-ticket-report/{id}`, id, null);
	}

	setStatus(resource) {
		return super.batchUpdate(`${this.base}/{id}/set-status{?pickTicketHeaderStatusId}`, resource);	
	}	

	refresh(id){
        return super.get(this.base + '/refresh/{id}', null, { id: id });
    }

	createPickTicketNewFlow() {
		return super.create(`${this.base}/create-facility-order-pick-ticket-new-flow`);
	}

	refreshNewFlow(id){
        return super.get(this.base + '/refresh-new-flow/{id}', null, { id: id });
    }

	pickTicketReportDownloadUrlNewFlow(id) {
		return super.get(`${this.base}/get-pick-ticket-report-new-flow/{id}`, id, null);
	}

	pickDeliveryReportDownloadUrlNewFlow(id) {
		return super.get(`${this.base}/get-delivery-ticket-report-new-flow/{id}`, id, null);
	}

	deliveryReportDownloadUrlNiko(id) {
		return super.get(`${this.base}/get-delivery-ticket-report-niko/{id}`, id, null);
	}

	pickTicketReportOrderSummaryDownloadUrlNewFlow(id) {
		return super.get(`${this.base}/get-pick-ticket-report-new-flow-order-summary/{id}`, id, null);
	}

	pickTicketReportDownloadUrlNiko(id) {
		return super.get(`${this.base}/get-pick-ticket-report-niko/{id}`, id, null);
	}

	getExcludedAndIncludedFacilityOrderTemplateItems(facilityOrderId) {		
		return super.get(`${this.base}/get-excluded-and-included-facility-order-template-items/{facilityOrderId}`, null, {facilityOrderId});	
	}	
	
	getSentSeparatelyFacilityOrderTemplateItems(facilityOrderId) {		
		return super.get(`${this.base}/get-sent-separately-facility-order-template-items/{facilityOrderId}`, null, {facilityOrderId});	
	}	
	
	sendInfoEmail(facilityOrderId) {
		return super.create(`${this.base}/send-info-email/{facilityOrderId}`,  { facilityOrderId });
	}

	update(resource) {
        return super.update(this.base + '/{id}', resource);
    }
	
	sendAgoraPo(id) {
		return super.get(`${this.base}/send-agora-po-report/{id}`, id, null);
	}

	agoraPoReportDownloadUrl(id) {
		return super.get(`${this.base}/get-agora-po-report/{id}`, id, null);
	}

	agoraPoReportDownloadUrlNiko(id) {
		return super.get(`${this.base}/get-agora-po-report-niko/{id}`, id, null);
	}

	sendAgoraPoNiko(id) {
		return super.get(`${this.base}/send-agora-po-report-niko/{id}`, id, null);
	}

	hasPickTicketItemsNiko(facilityOrderId, documentName) {
		return super.get(`${this.base}/has-pick-ticket-items-niko/{facilityOrderId}{?documentName}`, null, { facilityOrderId, documentName });
	}

	sendOrderOrderSummary(resource) {
		return super.update(`${this.base}/send-order-order-summary/{facilityOrderId}`, resource);	
	}
}

export default PickTicketHeaderRouteService;